import HttpClient from '../services/HttpClient'
import { ACTIVE_USERS_PATH } from '../constants'

export const getAllActiveUsersApi = () => {
   return HttpClient.get(
      `${process.env.REACT_APP_USERS_API}${ACTIVE_USERS_PATH}`
   )
      .then(response => response.data)
      .catch(err => Promise.reject(err))
}

export const getFilteredUSersApi = criteria => {
   return HttpClient.get(
      `${process.env.REACT_APP_USERS_API}${ACTIVE_USERS_PATH}?request=${criteria}`
   )
      .then(response => response.data)
      .catch(err => Promise.reject(err))
}
